import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import AddToQuotationNormalizersResolver from "./AddToQuotationNormalizersResolver";
export default class AddToQuotationDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new AddToQuotationNormalizersResolver());
        }
        return this.builderInstance;
    }
}
